import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

const AuthGuard = ({ children, component: Component, ...rest }) => {
  const { isAuth } = useSelector((state) => state.admin);

  // If used as wrapper (with children)
  if (children) {
    return isAuth ? children : <Redirect to="/login" />;
  }

  // If used as Route component (legacy)
  return isAuth ? <Component {...rest} /> : <Redirect to="/login" />;
};

export default AuthGuard;